export default __webpack_public_path__ + "static/media/gallery - story - other (1)_06.2cc393a3.jpg";